const BIG_CHAT_OPEN = 'BIG_CHAT_OPEN';
const BIG_CHAT_CLOSE = 'BIG_CHAT_CLOSE';

export const bigChatOpen = {
    type: BIG_CHAT_OPEN,
};

export const bigChatClose = {
    type: BIG_CHAT_CLOSE,
};
